import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';
import { appDisplayName } from 'src/assets/config/constants';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        appDisplayName,   //theme name
        true,       //loadingSpinner
        true,      //fixedHeader
        true,      //fixedSidenav
        true,      //fixedFooter
        true,       //sidenavIsOpened
        true,       //sidenavIsPinned
        'vertical', //horizontal , vertical
        'default',  //default, compact, mini
        'uss-theme',   //indigo-light, teal-light, red-light, gray-light, blue-dark, green-dark, pink-dark, gray-dark
        false       // true = rtl, false = ltr
    )
}

